import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["alertIconRef"];
const _c1 = ["*"];
function InlineAlertComponent_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 5);
    i0.ɵɵtext(1, "error_filled");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("icon-medium", !ctx_r0.rebrand);
  }
}
function InlineAlertComponent_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 5);
    i0.ɵɵtext(1, "warning_filled");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("icon-medium", !ctx_r0.rebrand);
  }
}
function InlineAlertComponent_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 5);
    i0.ɵɵtext(1, "information_filled");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("icon-medium", !ctx_r0.rebrand);
  }
}
function InlineAlertComponent_i_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 5);
    i0.ɵɵtext(1, "check_circle_filled");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("icon-medium", !ctx_r0.rebrand);
  }
}
function InlineAlertComponent_i_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 5);
    i0.ɵɵtext(1, "information_filled");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("icon-medium", !ctx_r0.rebrand);
  }
}
function InlineAlertComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function InlineAlertComponent_strong_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "strong");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
let InlineAlertComponent = /*#__PURE__*/(() => {
  class InlineAlertComponent {
    constructor(renderer) {
      this.renderer = renderer;
      this.type = 'error';
      this.width = 'default';
      this.label = undefined;
      this.rebrand = false;
    }
    ngOnInit() {
      // hide loading fallback-font for Symbols,
      // but only if we have window.document.fonts available (fixes test)
      if (window?.document?.fonts) {
        document.fonts.load('16px Storebrand Symbols').then(() => {
          this.renderer.addClass(this.alertIconRef.nativeElement, 'loaded');
        });
      } else {
        this.renderer.addClass(this.alertIconRef.nativeElement, 'loaded');
      }
    }
  }
  InlineAlertComponent.ɵfac = function InlineAlertComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InlineAlertComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  InlineAlertComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: InlineAlertComponent,
    selectors: [["stb-inline-alert"]],
    viewQuery: function InlineAlertComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alertIconRef = _t.first);
      }
    },
    inputs: {
      type: "type",
      width: "width",
      label: "label",
      rebrand: "rebrand"
    },
    ngContentSelectors: _c1,
    decls: 12,
    vars: 14,
    consts: [["alertIconRef", ""], [1, "inline-alert-icon"], ["class", "icon", "aria-hidden", "true", 3, "icon-medium", 4, "ngIf"], [1, "inline-alert-content", "font-small-demibold"], [4, "ngIf"], ["aria-hidden", "true", 1, "icon"]],
    template: function InlineAlertComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div")(1, "div", 1, 0);
        i0.ɵɵtemplate(3, InlineAlertComponent_i_3_Template, 2, 2, "i", 2)(4, InlineAlertComponent_i_4_Template, 2, 2, "i", 2)(5, InlineAlertComponent_i_5_Template, 2, 2, "i", 2)(6, InlineAlertComponent_i_6_Template, 2, 2, "i", 2)(7, InlineAlertComponent_i_7_Template, 2, 2, "i", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 3);
        i0.ɵɵtemplate(9, InlineAlertComponent_ng_container_9_Template, 2, 1, "ng-container", 4);
        i0.ɵɵprojection(10);
        i0.ɵɵtemplate(11, InlineAlertComponent_strong_11_Template, 2, 1, "strong", 4);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassMapInterpolate2("inline-alert ", ctx.type, " ", ctx.width, "");
        i0.ɵɵclassProp("rebrand", ctx.rebrand);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.type === "error");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.type === "warning");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.type === "info");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.type === "success");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.type === "subtle");
        i0.ɵɵadvance();
        i0.ɵɵattribute("role", ctx.type === "error" ? "alert" : "status");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.label && ctx.rebrand);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.label && !ctx.rebrand);
      }
    },
    dependencies: [i1.NgIf],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Symbols;src:url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.ttf) format(\"truetype\");text-rendering:optimizeLegibility}body[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-family:Storebrand Symbols!important}i[_ngcontent-%COMP%]{font-family:Storebrand Symbols!important;font-style:normal;font-weight:400!important;font-size:16px;line-height:16px;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}i[_ngcontent-%COMP%]:empty:not([class*=system-icon]){display:inline-flex;width:24px;height:24px;background:var(--color-primary)}.icon-xsmall[_ngcontent-%COMP%]{font-size:16px!important;line-height:16px!important}.icon-small[_ngcontent-%COMP%]{font-size:20px!important;line-height:20px!important}.icon-medium[_ngcontent-%COMP%]{font-size:24px!important;line-height:24px!important}.icon-large[_ngcontent-%COMP%]{font-size:32px!important;line-height:32px!important}.inline-alert.rebrand[_ngcontent-%COMP%]{--_stb-inline-bg-color: var(--stb-inline-bg-color, var(--p-color-surface-error, #ffdfdf));--_stb-inline-color: var(--stb-inline-color, var(--p-color-text-on-error, #770000));background-color:var(--_stb-inline-bg-color);border-radius:var(--p-corner-radius-small, 8px);box-sizing:border-box;color:var(--_stb-inline-color);display:flex;margin:0;padding:4px 8px}.inline-alert.rebrand[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{display:inline-block;font-size:1.125rem;height:1.125rem;line-height:1.25rem;opacity:0;width:1.125rem}@media (max-width: 600px){.inline-alert.rebrand[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{align-items:center;font-size:1rem!important;height:1rem;line-height:1rem!important;width:1rem}}.inline-alert.rebrand[_ngcontent-%COMP%]   .inline-alert-icon[_ngcontent-%COMP%]{align-self:center;color:var(--_stb-inline-color);display:flex;height:1.25rem;padding-top:0}.inline-alert.rebrand[_ngcontent-%COMP%]   .inline-alert-icon.loaded[_ngcontent-%COMP%]   i.icon[_ngcontent-%COMP%]{opacity:1}@media (max-width: 600px){.inline-alert.rebrand[_ngcontent-%COMP%]   .inline-alert-icon[_ngcontent-%COMP%]{align-items:center}}.inline-alert.rebrand[_ngcontent-%COMP%]   .inline-alert-content[_ngcontent-%COMP%]{padding-left:8px}.inline-alert.rebrand[_ngcontent-%COMP%]   .inline-alert-content.font-small-demibold[_ngcontent-%COMP%]{color:inherit;line-height:1.25rem}@media (max-width: 600px){.inline-alert.rebrand[_ngcontent-%COMP%]   .inline-alert-content[_ngcontent-%COMP%]{font-size:.875rem;line-height:1.25rem}}.inline-alert.rebrand.default[_ngcontent-%COMP%]{width:-moz-fit-content;width:fit-content}.inline-alert.rebrand.fluid[_ngcontent-%COMP%]{width:100%}.inline-alert.rebrand.large[_ngcontent-%COMP%]{max-width:35rem;min-width:18rem;width:-moz-fit-content;width:fit-content}.inline-alert.rebrand.error[_ngcontent-%COMP%]{--_stb-inline-bg-color: var(--p-color-surface-error);--_stb-inline-color: var(--p-color-text-on-error)}.inline-alert.rebrand.success[_ngcontent-%COMP%]{--_stb-inline-bg-color: var(--p-color-surface-success);--_stb-inline-color: var(--p-color-text-on-success)}.inline-alert.rebrand.info[_ngcontent-%COMP%]{--_stb-inline-bg-color: var(--p-color-surface-info);--_stb-inline-color: var(--p-color-text-on-info)}.inline-alert.rebrand.warning[_ngcontent-%COMP%]{--_stb-inline-bg-color: var(--p-color-surface-warning);--_stb-inline-color: var(--p-color-text-on-warning)}.inline-alert.rebrand.subtle[_ngcontent-%COMP%]{--_stb-inline-bg-color: var(--p-color-surface-1);--_stb-inline-color: var(--p-color-text-primary)}.inline-alert[_ngcontent-%COMP%]:not(.rebrand){display:flex;color:#191919;margin:8px 0;font-size:16px;font-family:Open Sans,sans-serif;line-height:normal;box-sizing:content-box}.inline-alert[_ngcontent-%COMP%]:not(.rebrand)   .inline-alert-icon[_ngcontent-%COMP%]{opacity:0}.inline-alert[_ngcontent-%COMP%]:not(.rebrand)   .inline-alert-icon[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{display:inline-block;height:24px;width:24px}.inline-alert[_ngcontent-%COMP%]:not(.rebrand)   .inline-alert-icon.loaded[_ngcontent-%COMP%]{opacity:1}.inline-alert.default[_ngcontent-%COMP%]{width:288px}.inline-alert.large[_ngcontent-%COMP%]{width:560px}.inline-alert.fluid[_ngcontent-%COMP%]{width:100%}.inline-alert-icon[_ngcontent-%COMP%]{padding-top:1px}.inline-alert[_ngcontent-%COMP%]:not(.rebrand).error   .inline-alert-icon[_ngcontent-%COMP%]{color:#e36a31}.inline-alert[_ngcontent-%COMP%]:not(.rebrand).warning   .inline-alert-icon[_ngcontent-%COMP%]{color:#c17b0b}.inline-alert[_ngcontent-%COMP%]:not(.rebrand).info   .inline-alert-icon[_ngcontent-%COMP%]{color:#2a8eac}.inline-alert[_ngcontent-%COMP%]:not(.rebrand).success   .inline-alert-icon[_ngcontent-%COMP%]{color:#4a966e}.inline-alert[_ngcontent-%COMP%]:not(.rebrand)   .inline-alert-content[_ngcontent-%COMP%]{padding-left:20px;line-height:24px}.inline-alert[_ngcontent-%COMP%]:not(.rebrand)   .inline-alert-content[_ngcontent-%COMP%] > strong[_ngcontent-%COMP%]{margin-top:0;font-size:16px;line-height:24px;font-family:Open Sans,sans-serif;font-weight:600;display:inline-block}"]
  });
  return InlineAlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InlineAlertModule = /*#__PURE__*/(() => {
  class InlineAlertModule {}
  InlineAlertModule.ɵfac = function InlineAlertModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InlineAlertModule)();
  };
  InlineAlertModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: InlineAlertModule
  });
  InlineAlertModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return InlineAlertModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { InlineAlertComponent, InlineAlertModule };
